import { IApiRequest } from "@miplatform/types";
import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_USER_CAPACITIES = `${TASK_SERVICE}/user-capacities`;

export const userCapacities = {
  getDefaultsForCalendarSet: async ({ id, signal }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: `${API_USER_CAPACITIES}/default/${id}`,
      method: "get",
      signal,
    });
    return apiRequest(options);
  },
  getForCalendar: async (
    calendarSetId: string,
    from: Date,
    to: Date,
    signal: AbortSignal | undefined
  ) => {
    const options = await apiOptions({
      url: `${API_USER_CAPACITIES}/calendar-sets/${calendarSetId}`,
      method: "get",
      params: { from, to },
      signal,
    });
    return apiRequest(options);
  },
  updateDefault: async ({ data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_USER_CAPACITIES}/default`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  updateDaily: async ({ data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_USER_CAPACITIES}/daily`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
